import { render, staticRenderFns } from "./VariationAlertFormComponent.vue?vue&type=template&id=3c1f7b14&scoped=true&"
import script from "./VariationAlertFormComponent.vue?vue&type=script&lang=js&"
export * from "./VariationAlertFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./VariationAlertFormComponent.vue?vue&type=style&index=0&id=3c1f7b14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1f7b14",
  null
  
)

export default component.exports